import { render } from "./DeviceKeyboard.vue?vue&type=template&id=2aa314c0&scoped=true&ts=true&lang=pug"
import script from "./DeviceKeyboard.vue?vue&type=script&lang=ts"
export * from "./DeviceKeyboard.vue?vue&type=script&lang=ts"

import "./DeviceKeyboard.vue?vue&type=style&index=0&id=2aa314c0&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aa314c0"]])

export default __exports__